import React, {useMemo} from 'react';

const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL || 'https://img.knaek.com/';

function normalizeImageSrc(src) {
    if (!src || typeof src !== 'string') return src;

    if (
        src.startsWith('http://') ||
        src.startsWith('https://') ||
        src.startsWith('data:') ||
        src.startsWith('blob:')
    ) {
        return src;
    }

    const normalizedBase = imageBaseUrl.endsWith('/') ? imageBaseUrl : `${imageBaseUrl}/`;
    const normalizedSrc = src.startsWith('undefined/') ? src.replace(/^undefined\//, '') : src.replace(/^\/+/, '');

    return `${normalizedBase}${normalizedSrc}`;
}

export default function ImageComponent(props) {
    return useMemo(() => (
        <img src={normalizeImageSrc(props.src)} alt={props.alt} className={props.className}/>
    ), [props.src, props.alt, props.className]);
}
